<template>
  <div class="copyrightMonitoringUp">
    <div class="topNav">
      <img class="img" src="../../assets/index.png" alt="">
      <div class="r">></div>
      <div class="text">版权服务</div>
      <div class="r">></div>
      <div class="text active">版权监测</div>
    </div>
    <div class="topTitle">
      <div class="title">版权监测</div>
      <div class="msg">通过全网监测技术，及时发现互联网上的侵权线索</div>
    </div>
    <div class="contentBox">
      <div class="content">
        <div class="title">版权监测</div>
        <div class="formBox">
          <div class="item boderB">
            <div class="lable">选择监测类型：</div>
            <div class="leixingBox">
              <div class="leixinItm" :class="monitorIdx == index?'active':''" v-for="(item,index) in monitorType" :key="index" @click="onMonitorType(index)">
                <div class="line"></div>
                <div class="t">{{item.name}}</div>
              </div>
            </div>
          </div>
          <!-- 图片监测 -->
          <div v-if="monitorIdx == 0">
            <div class="item">
              <div class="lable">确认监测作品：</div>
              <div class="upImgBox">
                <div class="list enterprise">
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    >
                    <img v-if="enterpriseImg" :src="enterpriseImg" class="avatar">
                    <img v-else class="addUp" src="../../assets/addUp.png" alt="">
                    <div class="textMsg">请上传作品图片</div>
                  </el-upload>
                </div>
                <div class="tipMsg">
                  <p class="p">温馨提示：</p>
                  1、支持上传格式png、jpg、jpeg；<br>
                  2、上传文件大小不得超过20M；<br>
                  3、图片尺寸需大于200*200；<br>
                </div>
              </div>
            </div>
            <div class="item boderB">
              <div class="lable">设定关键词：</div>
              <el-input class="elinput" v-model="input" placeholder="请输入图片描述（作品名称、作者等）"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">选择监测范围：</div>
              <div class="fanweiBox">
                <div class="fanItem active">微信公众平台</div>
                <div class="fanItem">电商网站</div>
                <div class="fanItem">搜索引擎</div>
                <div class="fanItem">图库素材</div>
              </div>
            </div>
          </div>
          <!-- 音乐监测 -->
          <div v-else-if="monitorIdx == 1">
            <div class="item boderB">
              <div class="lable">歌曲名称：</div>
              <el-input class="elinput" v-model="input" placeholder="请输入歌曲名称"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">歌手姓名：</div>
              <el-input class="elinput" v-model="input" placeholder="请输入歌手姓名"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">设定监测名称：</div>
              <el-input class="elinput" v-model="input" placeholder="监测名称可以区分您多次监测的内容"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">选择监测范围：</div>
              <div class="fanweiBox">
                <div class="fanItem active">虾米音乐网</div>
                <div class="fanItem">清风dj</div>
                <div class="fanItem">QQ音乐</div>
                <div class="fanItem">一听音乐</div>
                <div class="fanItem">清风dj</div>
                <div class="fanItem">QQ音乐</div>
                <div class="fanItem">一听音乐</div>
              </div>
            </div>
          </div>
          <!-- 文字监测 -->
          <div v-else-if="monitorIdx == 2">
            <div class="item boderB">
              <div class="lable">监测关键词：</div>
              <el-input class="elinput" v-model="input" placeholder="请输入监测关键词，限20个字内"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">设定监测名称：</div>
              <el-input class="elinput" v-model="input" placeholder="监测名称可以区分您多次监测的内容"></el-input>
            </div>
            <div class="item boderB">
              <div class="lable">选择监测范围：</div>
              <div class="fanweiBox">
                <div class="fanItem active">新闻周刊</div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">确认提交</div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "ganan_copyrightMonitoringUp",
      data(){
        return {
          enterpriseImg: '', //身份证正面
          input: '',
          monitorIdx: 0,
          monitorType: [
            {
              name: '图片监测'
            },
            {
              name: '音乐监测'
            },
            {
              name: '文字监测'
            }
          ]
        }
      },
			components: {
			},
      methods: {
        onMonitorType(index) {
          this.monitorIdx = index
        }
      },
			watch: {
				$route(to, from) {

				}
			}
    };
</script>

<style lang="less" scoped>
.copyrightMonitoringUp{
  background: #F4F8FC;
  color: #333;
}
.topNav{
  display: flex;
  align-items: center;
  width: 1200px;
  margin: auto;
  padding: 18px 0;
  font-size: 14px;
  color:#999999;
  .img{
    width: 16px;
    height: 16px;
  }
  .r{
    margin: 0 10px;
  }
  .active{
    color: #2196F3;
  }
}
.topTitle{
  width: 1200px;
  background: #fff;
  margin: auto;
  text-align: center;
  padding: 33px;
  border-radius: 8px;
  .title{
    text-align: center;
    font-size: 22px;
    font-weight: 700;
  }
  .msg{
    font-size: 14px;
    margin-top: 6px;
    color:#666666;
  }
}
.contentBox{
  padding: 20px 0;
  .content{
    width: 1200px;
    background: #fff;
    border-radius: 8px;
    padding: 36px 48px;
    margin: auto;
    .title{
      font-size: 20px;
      font-weight: 700;
      position: relative;
      z-index: 2;
      &::before{
        content: '';
        position: absolute;
        width: 36px;
        background: #2196F3;
        height: 6px;
        border-radius: 3px;
        left: 0;
        bottom: 3px;
        z-index: -1;
      }
    }
    .formBox{
      padding: 52px 0 0 0;
      .item{
        display: flex;
        font-size: 14px;
        padding: 26px 0;
        .lable{
          flex: 0 0 98px;
          text-align: right;
          color:#666666;
          line-height: 40px;
        }
        .leixingBox{
          display: flex;
          align-items: center;
          margin-left: 25px;
          .leixinItm{
            display: flex;
            align-items: center;
            margin-right: 72px;
            cursor: pointer;
            .line{
              width: 12px;
              height: 12px;
              border-radius: 2px;
              border: 1px solid #B5B5B5;
            }
            .t{
              font-size: 14px;
              margin-left: 10px;
              color: #999;
            }
          }
          .active{
            .line{
              background: #2196F3;
              border: solid 1px #2196F3;
            }
            .t{
              color: #333;
            }
          }
        }
        .fanweiBox{
          display: flex;
          align-items: center;
          margin-left: 25px;
          flex-wrap: wrap;
          .fanItem{
            width: 136px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #B9B9B9;
            border-radius: 4px;
            color: #999999;
            font-size: 14px;
            text-align: center;
            margin-right: 20px;
            cursor: pointer;
            margin-bottom: 20px;
          }
          .active{
            background: #2196F3;
            color: #fff;
            border: 1px solid #2196F3;
          }
        }
        .upImgBox{
          display: flex;
          align-items: flex-end;
          margin-left: 25px;
          .list{
            width: 198px;
            height: 152px;
            border: dashed 1px #E5E5E5;
            padding: 12px;
            border-radius: 4px;
            margin-right: 17PX;
            position: relative;
            .avatar{
              width: 100%;
              height: 98px;
              margin: auto;
            }
            .addUp{
              width: 30px;
              height: 27px;
              margin: auto;
            }
            /deep/ .avatar-uploader{
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              overflow: hidden;
            }
            /deep/ .el-upload{
              width: 100%;
              padding: 25% 0;
            }
            .textMsg{
              text-align: center;
              font-size: 12px;
              margin-top: 12px;
            }
          }
          .enterprise{
            height: auto;
            min-height: 152px;
            .avatar{
              width: 100%;
              height: auto;
              min-height: 98px;
              margin: auto;
            }
          }
          .tipMsg{
            font-size: 14px;
            color:#999999;
            margin-left: 25px;
            .p{
              margin-bottom: 10px;
            }
          }
        }
        .elinput{
          margin-left: 25px;
          width: 434px;
        }
      }
      .boderB{
        border-bottom: solid 1px #E5E5E5;
      }
    }
    .btn{
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      width: 170px;
      height: 40px;
      background: #2196F3;
      border-radius: 4px 4px 4px 4px;
      line-height: 40px;
      margin: 56px auto;
      cursor: pointer;
    }
  }
  
}
</style>
